module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/014-wales-2297fd61af205bee5a6b2b38640e2238.svg";